// 创建人:穆童
// 创建时间 : 20230211
// 模块名称: 接口配置

// 本地
// var baseUrl = "http://192.168.1.245:8088"; //文/亮
//测试
// var baseUrl = "https://192.168.1.162:8088";

//线上
var baseUrl = "https://www.hdsfxq.com:9098";
// var baseUrl = "https://127.0.0.1:8088";

// var baseUrl = "https://114.116.253.52:8088";
//全局配置变量
var numduration = 1000; //页面数字跳动时间
export default {
  title: '活力复兴系统',
  baseUrl,
  numduration,
  loadurl: {
    // 开始
    VerifyCode: baseUrl + '/home/kaptcha/getVerifCode', //获取验证码
    userLogin: baseUrl + '/api/users/dologin', //用户登陆
    loadMenu: baseUrl + '/api/menu/loadmenu', //权限菜单
    getLevelList: baseUrl + '/api/menu/getMenuList', //菜单列表展示（树形）
    getMenuNoBtnList: baseUrl + '/api/menu/getMenuNoBtnList', //获取菜单列表（无按钮）
    getRouterMenuList: baseUrl + '/api/menu/getRouterMenuList', //获取路由菜单列表
    addAndUpLevels: baseUrl + '/api/menu/addAndUpMenus', //添加编辑菜单
    deleteLevels: baseUrl + '/api/menu/deleteMenus', //删除菜单
    selectRolesList: baseUrl + '/api/roles/getRolesAll', //角色下拉列表
    getRolesList: baseUrl + '/api/roles/getRolesList', //角色列表
    upAndAddRoles: baseUrl + '/api/roles/addAndUpRoles', //添加编辑角色
    delRoles: baseUrl + '/api/roles/delRoles', //删除角色
    getUserList: baseUrl + '/api/users/getUserList', //用户列表
    addAndUpUserMessage: baseUrl + '/api/users/addAndUpUserMessage', //添加编辑用户
    delUser: baseUrl + '/api/users/delUser', //删除用户
    getUserMessage: baseUrl + '/api/users/getUserMessage', //获取基本资料
    upUsersMessage: baseUrl + '/api/users/upUsersMessage', //修改个人信息
    upUserPwd: baseUrl + '/api/users/upUserPwd', //修改密码
    upReSetUserPwd: baseUrl + '/api/users/upReSetUserPwd', //密码重置
    uploadAvatar: baseUrl + '/api/upload/uploadAvatar', //上传头像
    uploadThumbnail: baseUrl + '/api/upload/uploadThumbnail',
    /* 缩略图上传 */
    uploadIllustration: baseUrl + '/api/upload/uploadIllustration',
    /* 上传富文本插图 */
    uploadVideo : baseUrl+ '/api/upload/uploadVideo',/*视频上传*/
    getWebsiteInfo: baseUrl + '/api/website/getWebsiteInfo', //获取系统设置
    upWebsiteInfo: baseUrl + '/api/website/upWebsiteInfo', //系统设置编辑
    getMenuBtnList: baseUrl + '/api/menu/getMenuBtnList', //根据用户ID与菜单ID获取按钮
    getLogList: baseUrl + '/api/logs/getLogList', //系统日志列表
    getTouristList: baseUrl + '/api/tourist/getTouristList', //获取游客列表
    addAndUpTouristMessage: baseUrl + '/api/tourist/addAndUpTouristMessage', //游客添加编辑
    delTourist: baseUrl + '/api/tourist/delTourist', //删除游客
    getOrganizationlist: baseUrl + '/api/organization/getOrganizationlist', //加载部门列表
    loadOrganizationtTree: baseUrl + '/api/organization/loadOrganizationtTree', //加载部门列表（树形结构）
    addAndUpOrganization: baseUrl + '/api/organization/addAndUpOrganization', //添加编辑部门
    deleteOrganization: baseUrl + '/api/organization/deleteOrganization', //删除部门
    verifyLoginName: baseUrl + '/api/users/verifyLoginName', //验证用户名
    verifyPhoneOrIdCard: baseUrl + '/api/users/verifyPhoneOrIdCard', //验证手机号或者身份证号
    verifySetPwd: baseUrl + '/api/users/verifySetPwd', //设置密码
    getTimedtaskList: baseUrl + '/api/timedtask/getTimedtaskList', //获取定时任务列表
    addAndUpTimedtask: baseUrl + '/api/timedtask/addAndUpTimedtask', //添加编辑定时任务
    delTimedtask: baseUrl + '/api/timedtask/delTimedtask', //删除定时任务

    // 结束
    // 李一凡开始 新闻中心管理
    getArticlelist: baseUrl + '/api/news/getNewslist',
    /* 获取新闻列表 */
    ///doupload/uploadThumbnail
    addAndUpArticle: baseUrl + '/api/news/addAndUpNews',
    /* 添加新闻 */
    addAndUpdata: baseUrl + '/api/news/addAndUpNews',
    /*编辑新闻  */
    delArticle: baseUrl + '/api/news/delNews',
    /* 删除新闻 */
    chgNewsApproval: baseUrl + '/api/news/chgNewsApproval',
    /* 新闻审批 */
    NewsPublic: baseUrl + '/api/news/NewsPublic',
    /* 新闻发布 */
    // 李一凡结束 新闻中心管理
    // 李一凡开始 政务动态管理
    getGovernDynamicList: baseUrl + '/api/governDynamic/getGovernDynamicList',
    /* 获取政务动态列表 */
    addAndUpGovernDynamic: baseUrl + '/api/governDynamic/addAndUpGovernDynamic',
    /* 添加政务动态 */
    delGovernDynamic: baseUrl + '/api/governDynamic/delGovernDynamic',
    /* 删除政务动态 */
    addAndUpGoverdata: baseUrl + '/api/governDynamic/addAndUpGovernDynamic',
    /* 编辑政务动态 */
    chgGovernDynamicApproval: baseUrl + '/api/governDynamic/chgGovernDynamicApproval',
    /* 政务动态批审 */
    governDynamicPublic: baseUrl + '/api/governDynamic/governDynamicPublic',
    /* 政务动态发布 */
    // 李一凡结束 政务动态管理
    // 李一凡开始 政府职能管理
    getGovernFunctionalList: baseUrl + '/api/governFunctional/getGovernFunctionalList',
    /* 政府职能列表 */
    addAndUpGovernFunctional: baseUrl + '/api/g overnFunctional/addAndUpGovernFunctional',
    /* 添加 编辑政府职能 */
    delGovernFunctional: baseUrl + '/api/governFunctional/delGovernFunctional',
    /* 删除政府职能 */
    chgGovernFunctionalApproval: baseUrl + '/api/governFunctional/chgGovernFunctionalApproval',
    /* 政府职能审批 */
    governFunctionalPublic: baseUrl + '/api/governFunctional/governFunctionalPublic',
    /* 政府职能发布 */
    // 李一凡结束 政府职能管理
    // 李一凡 社会经济发展
    getSocioeconomicList: baseUrl + '/api/socioeconomic/getSocioeconomicList',
    /* 获取社会经济发展列表 */
    addAndUpSocioeconomic: baseUrl + '/api/socioeconomic/addAndUpSocioeconomic',
    /* 添加编辑社会经济发展 */
    delSocioeconomic: baseUrl + '/api/socioeconomic/delSocioeconomic',
    /* 删除社会经济发展 */
    chgSocioeconomicApproval: baseUrl + '/api/socioeconomic/chgSocioeconomicApproval',
    /* 社会经济发展审批 */
    socioeconomicPublic: baseUrl + '/api/socioeconomic/socioeconomicPublic',
    /* 社会经济发展发布 */
    // 本地登录结束
    // 李一凡开始 景区概况管理
    // http://localhost:8080/api/scenicSpot/getList
    getListid: baseUrl + '/api/scenicSpot/getList',
    getList: baseUrl + '/api/scenicSpot/getScenicSpotList',
    /* 获取景区 概况列表*/
    addAndUpScenicSpot: baseUrl + '/api/scenicSpot/addAndUpScenicSpot',
    /* 添加编辑景区概况 */
    delScenicSpot: baseUrl + '/api/scenicSpot/getScenicSpotList',
    /* 删除景区概况 */
    scenicSpotPublic: baseUrl + '/api/scenicSpot/scenicSpotPublic',
    /* 景区概况发布 */

    // 李一凡结束 景区概况管理
    // 李一凡开始 景区景致管理
    //   http://localhost:8080/api/scenicPoint/scenicPointPublic
    getScenicPointList: baseUrl + '/api/scenicPoint/getScenicPointList',/* 获取重点景致列表 */
    addAndUpScenicPoint: baseUrl + '/api/scenicPoint/addAndUpScenicPoint',/* 添加重点景致 */
    delScenicPoint: baseUrl + '/api/scenicPoint/delScenicPoint',/* 删除重点景致 */
    scenicPointPublic: baseUrl + '/api/scenicPoint/scenicPointPublic',/* 重点景致发布 */
    // 李一凡结束 景区景致管理
    // 李一凡开始 旅游服务管理
    //   http://localhost:8080/api/resources/delTouristResources
    getTouristResources: baseUrl + '/api/services/getTourismServicesList', /* 旅游服务管理 */
    addAndUpTouristResource: baseUrl + '/api/services/addAndUpTourismServices', /* 旅游服务添加 */
    delTouristResource: baseUrl + '/api/services/delTourismServices',           /* 旅游服务删除 */
    //穆童开始
    getDictList: baseUrl + '/api/dict/getDictList',  /* 获取字典列表 */
    delDictList: baseUrl + '/api/dict/deleteDict',  /* 字典列表删除 */
    addAndUpDict: baseUrl + '/api/dict/addAndUpDict',/* 字典列表添加 */
    getArtList: baseUrl + '/art/getArtList',/* 文章分类列表 */
    addAndUpArtcalss: baseUrl + '/art/addAndUpArtcalss',/* 文章分类添加 */
    deleteArtcalss: baseUrl + '/art/deleteArtclass', /* 文章分类删除 */
    getArticleList: baseUrl + '/art/getArticleList',/* 文章管理列表 */
    getLogList: baseUrl + '/api/logs/getLogList',/*用户操作日志列表*/
    getHotlineList: baseUrl + '/hotline/getHotlineList',/*热线列表*/
    deleteArticle: baseUrl + '/art/deleteArticle',/*文章管理删除*/
    addAndUpArticle: baseUrl + '/art/addAndUpArticle',/*文章管理添加*/
    addAndUpdate: baseUrl + '/hotline/addAndUpdate',/*热线添加*/
    deleteHotline: baseUrl + '/hotline/deleteHotline',/*热线删除*/
    getIndustryList: baseUrl + '/industry/getIndustryList',/*产业管理列表*/
    getProjectList: baseUrl +'/project/getProjectList',/*项目信息列表*/
    getRLandList: baseUrl + '/rland/getRLandList',/*地块信息列表*/
    getbasiclist: baseUrl + '/rland/getbasiclist',/*地块管理列表*/
    getlxlist: baseUrl + '/xmpublic/getlxlist',/*项目类型字典列表*/
    deleteIndustry: baseUrl + '/industry/deleteIndustry',/*产业删除*/
    addAndUpIndustry: baseUrl + '/industry/addAndUpIndustry',/*产业添加*/
    projectaddAndUpdate: baseUrl + '/project/addAndUpdateProject',/*项目添加*/
    deleteProject: baseUrl + '/project/deleteProject',/*项目删除*/
    getEnterpriseList: baseUrl + '/enterprise/getEnterpriseList',/*企业管理列表*/
    deleteEnterprise: baseUrl + '/enterprise/deleteEnterprise',/*企业删除*/
    enterpriseaddAndUpdate: baseUrl + '/enterprise/addAndUpdate',/*企业添加*/
    deleteRland: baseUrl + '/rland/deleteRland',/*地块删除*/
    addAndUpdateLand: baseUrl + '/rland/addAndUpdateLand',/*地块添加*/
    getConsulatList: baseUrl + '/consulat/getConsulatList',/*咨询管理*/
    AddandUpConsulat: baseUrl + '/consulat/AddandUpConsulat',/*咨询添加*/
    deleteConsulat: baseUrl + '/consulat/deleteConsulat',/*咨询删除*/
    getPlateList: baseUrl + '/plate/getPlateList',/*地块列表*/
    getLinksGroupList: baseUrl + '/linksgroup/getLinksGroupList',/*链接类型管理列表*/
    addAndUpdateLinksGroup: baseUrl + '/linksgroup/addAndUpdateLinksGroup',/*链接类型添加*/
    deleteLinksGroup: baseUrl + '/linksgroup/deleteLinksGroup',/*链接类型删除*/
    getLinksList: baseUrl + '/links/getLinksList',/*链接列表*/
    addAndUpdateLinks: baseUrl + '/links/addAndUpdateLinks',/*链接添加*/
    deleteLinks: baseUrl + '/links/deleteLinks',/*链接删除*/
    getBuildingList: baseUrl + '/building/getBuildingList',/*楼宇信息列表*/
    AddandUpBuilding: baseUrl + '/building/AddandUpBuilding',/*增加楼宇*/
    deleteBuilding: baseUrl + '/building/deleteBuilding',/*删除楼宇*/
    deleteBuilding: baseUrl + '/building/deleteBuilding',/*删除楼宇*/
    getScreenMiniList: baseUrl + '/rland/getScreenMiniList',/*类型筛选*/
    addAndUpdateHotline: baseUrl + '/hotline/addAndUpdateHotline',/*热线添加*/
    deleteHotline: baseUrl + '/hotline/deleteHotline',/*热线删除*/
    getUserListContainsRoleId : baseUrl+ '/api/users/getUserListContainsRoleId',/*热线删除*/
    uploadVideo : baseUrl+ '/api/upload/uploadVideo',/*视频上传*/
    getIndustryMiniList: baseUrl+'/industry/getIndustryMiniList',/*产业链列表*/
    addAndUpIndustryMini: baseUrl+'/industry/addAndUpIndustryMini',/*产业链添加*/
    delIndustryMini: baseUrl+'/industry/delIndustryMini',/*产业链添加*/
    getStreetList: baseUrl+'/api/street/getStreetList',/*街道列表*/
    updateStreet: baseUrl+'/api/street/updateStreet',/*街道编辑*/
    uploadVideofuc: baseUrl+'/api/video/uploadVideo',/*视频上传*/
    getVideo: baseUrl+'/api/video/getVideo',/*视频列表*/
    //穆童结束










  //wangjigngjing开始
  getRegulatorylist: baseUrl + '/api/regulatory/getRegulatorylist', //法规文件列表
  delRegulatory: baseUrl + '/api/regulatory/delRegulatory', //法规文件删除
  addAndUpRegulatory: baseUrl + '/api/regulatory/addAndUpRegulatory', //法规文件编辑添加
  RegulatoryPublic: baseUrl + '/api/regulatory/RegulatoryPublic', //法规文件发布
  delRegulatory: baseUrl + '/api/regulatory/delRegulatory', //法规文件删除
  chgRegulatoryApproval: baseUrl + '/api/regulatory/chgRegulatoryApproval', //法规文件审批
  getWorkServiceList: baseUrl + '/api/workService/getWorkServiceList', //办事服务列表
  delWorkService: baseUrl + '/api/workService/delWorkService', //办事服务删除
  addAndUpWorkService: baseUrl + '/api/workService/addAndUpWorkService', //办事服务编辑添加
  workServicePublic: baseUrl + '/api/workService/workServicePublic', //办事服务发布
  chgWorkServiceApproval: baseUrl + '/api/workService/chgWorkServiceApproval', //办事服务审批
  getParticipationList: baseUrl + '/api/participation/getParticipationList', //公众参与列表
  delParticipation: baseUrl + '/api/participation/delParticipation', //公众参与删除
  addAndUpParticipation: baseUrl + '/api/participation/addAndUpParticipation', //公众参与编辑添加
  participationPublic: baseUrl + '/api/participation/participationPublic', //公众参与发布
  chgParticipationApproval: baseUrl + '/api/participation/chgParticipationApproval', //公众参与审批
  getTouristResourcesList: baseUrl + '/api/resources/getTouristResourcesList', //旅游资源管理列表
  delTouristResources: baseUrl + '/api/resources/delTouristResources', //旅游资源管理删除
  addAndUpTouristResources: baseUrl + '/api/resources/addAndUpTouristResources', //旅游资源管理编辑添加
  getTourismProductList: baseUrl + '/api/product/getTourismProductList', //旅游产品管理列表
  delTourismProduct: baseUrl + '/api/product/delTourismProduct', //旅游产品管理删除
  addAndUpTourismProduct: baseUrl + '/api/product/addAndUpTourismProduct', //旅游产品管理编辑添加
  scenicgetList: baseUrl + '/api/scenicSpot/getList', //景区概况列表（无分页）
  getInvestigationList: baseUrl + '/api/investigation/getInvestigationList', //在线调查管理列表
  delInvestigation: baseUrl + '/api/investigation/delInvestigation', //在线调查管理删除
  addAndUpInvestigation: baseUrl + '/api/investigation/addAndUpInvestigation', //在线调查管理编辑添加


  //wangjigngjing---------END




  }
}



// WEBPACK FOOTER //
// ./src/config/constant.js